import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../styles/media'
import { fonts } from '../../styles/theme'

const S = {}

const fontStyle = (type, size) => {
  const fonts = {
    headline: {
      xl: css`
        font-size: 3.375rem;
        --line-height: 4rem;
      `,
      l: css`
        font-size: 2.125rem;
        --line-height: 2.75rem;
      `,
      m: css`
        font-size: 1.75rem;
        --line-height: 2.25rem;
      `,
      s: css`
        font-size: 1.5rem;
        --line-height: 2rem;
      `,
      xs: css`
        font-size: 1.375rem;
        --line-height: 1.75rem;
      `,
      xxs: css`
        font-size: 1.25rem;
        --line-height: 1.625rem;
      `,
    },
    copy: {
      xl: css`
        font-size: 1.125rem;
        --line-height: 1.625rem;
      `,
      l: css`
        font-size: 1rem;
        --line-height: 1.5rem;
      `,
      m: css`
        font-size: 0.875rem;
        --line-height: 1.125rem;
      `,
      s: css`
        font-size: 0.75rem;
        --line-height: 1rem;
      `,
      xs: css`
        font-size: 0.625rem;
        --line-height: 0.875rem;
      `,
    },
  }

  return fonts[type][size]
}

S.Text = styled.p`
  font-family: ${({ useCustomFont }) =>
    useCustomFont ? 'inherit' : fonts.body};
  line-height: var(--line-height);

  [lang='th'] & {
    font-family: ${({ useCustomFont }) =>
      useCustomFont ? 'inherit' : fonts.notoSansThai};
  }

  [lang='kr'] & {
    font-family: ${({ useCustomFont }) =>
      useCustomFont ? 'inherit' : fonts.notoSansKr};
  }

  [lang='tw'] & {
    font-family: ${({ useCustomFont }) =>
      useCustomFont ? 'inherit' : fonts.notoSansTc};
  }

  ${({ weight }) =>
    weight === 'normal' &&
    css`
      font-weight: 400;
    `};

  ${({ weight }) =>
    weight === 'medium' &&
    css`
      font-weight: 500;
    `};

  ${({ weight }) =>
    weight === 'semibold' &&
    css`
      font-weight: 600;
    `};

  ${({ weight }) =>
    weight === 'bold' &&
    css`
      font-weight: 700;
    `};

  ${({ weight }) =>
    weight === 'heavy' &&
    css`
      font-weight: 800;
    `};

  ${({ weight }) =>
    weight === 'black' &&
    css`
      font-weight: 900;
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xl' &&
    type === 'copy' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'l')};

      ${media.sm`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xl' &&
    type === 'copy' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'l' &&
    type === 'copy' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'm')};

      ${media.sm`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'l' &&
    type === 'copy' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type }) =>
    size === 'm' &&
    type === 'copy' &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type }) =>
    size === 's' &&
    type === 'copy' &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type }) =>
    size === 'xs' &&
    type === 'copy' &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xl' &&
    type === 'headline' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'm')};

      ${media.sm`
        ${fontStyle(type, 'l')};
      `};

      ${media.md`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xl' &&
    type === 'headline' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'l' &&
    type === 'headline' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 's')};

      ${media.sm`
        ${fontStyle(type, 'm')};
      `};

      ${media.md`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'l' &&
    type === 'headline' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'm' &&
    type === 'headline' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'xs')};

      ${media.sm`
        ${fontStyle(type, 's')};
      `};

      ${media.md`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'm' &&
    type === 'headline' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 's' &&
    type === 'headline' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'xxs')};

      ${media.sm`
        ${fontStyle(type, 'xs')};
      `};

      ${media.md`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 's' &&
    type === 'headline' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xs' &&
    type === 'headline' &&
    !isFixedSize &&
    css`
      ${fontStyle(type, 'xxs')};

      ${media.sm`
        ${fontStyle(type, size)};
      `};
    `};

  ${({ size, type, isFixedSize }) =>
    size === 'xs' &&
    type === 'headline' &&
    isFixedSize &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ size, type }) =>
    size === 'xxs' &&
    type === 'headline' &&
    css`
      ${fontStyle(type, size)};
    `};

  ${({ smSize, type }) => smSize && fontStyle(type, smSize)};

  ${({ mdSize, type }) =>
    mdSize &&
    css`
      ${media.sm`
        ${fontStyle(type, mdSize)};
      `};
    `};

  ${({ lgSize, type }) =>
    lgSize &&
    css`
      ${media.md`
        ${fontStyle(type, lgSize)};
      `};
    `};

  ${({ headline, useCustomFont }) =>
    headline === 'carousel' &&
    css`
      font-family: ${useCustomFont ? 'inherit' : fonts.nutmeg};
      letter-spacing: -0.03125rem;
      font-weight: 700;

      [lang='ru'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.noirPro};
        font-weight: 600;
      }

      [lang='th'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansThai};
        font-weight: 600;
      }

      [lang='kr'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansKr};
        font-weight: 600;
      }

      [lang='tw'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansTc};
        font-weight: 600;
      }
    `};

  ${({ headline, useCustomFont }) =>
    headline === 'feed' &&
    css`
      font-family: ${useCustomFont ? 'inherit' : fonts.nutmegBook};
      letter-spacing: -0.03125rem;
      font-weight: 400;

      [lang='ru'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.noirPro};
        font-weight: 400;
      }

      [lang='th'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansThai};
        font-weight: 400;
      }

      [lang='kr'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansKr};
        font-weight: 400;
      }

      [lang='tw'] & {
        font-family: ${useCustomFont ? 'inherit' : fonts.notoSansTc};
        font-weight: 400;
      }
    `};
`

export default S
